export enum MenuActionId {
  ADD_NEW_SERVICE = 'add-new-service',
  ADD_NEW_PROJECT = 'add-new-project',
  ADD_NEW_WORKSPACE = 'add-new-workspace',
  CREATE_PROJECT_DIALOG = 'create-project-dialog',
  CREATE_WORKSPACE = 'create-workspace',
  PROJECT_SETTINGS = 'project-settings',
  PROJECT_MEMBERS = 'project-members',
  INVITE_PEOPLE = 'invite-people',
  WORKSPACE_SETTINGS = 'workspace-settings',
}
